import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export const SeoContent = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Seção principal sobre aluguel de motos */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Por que escolher a <span className="text-green-600">Desloca</span> para aluguel de motos?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Somos a <strong>locadora de motos</strong> mais confiável da Baixada Santista. 
            Nosso <strong>aluguel de moto</strong> inclui tudo que você precisa para andar com segurança e tranquilidade.
          </p>
        </div>

        {/* Grid com informações importantes */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                🏍️ <span>Aluguel de Moto Completo</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">
                Nosso <strong>aluguel de motocicleta</strong> inclui seguro, IPVA e suporte 24 horas.
                Troca de óleo por nossa conta nos planos <strong>Mensal e Anual</strong> — no plano
                <strong> Fidelidade</strong>, todas as manutenções ficam por conta da Desloca.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                🛡️ <span>Locadora Confiável</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">
                Como <strong>locadora de motos</strong> estabelecida, garantimos transparência total. 
                Sem taxas ocultas, sem pegadinhas. Tudo incluído no valor do aluguel.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                ⚡ <span>Processo Rápido</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">
                <strong>Aluguel de moto</strong> descomplicado. Documentação simples, 
                aprovação rápida e você sai com sua moto no mesmo dia.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* FAQ otimizada para SEO */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
            Perguntas Frequentes sobre Aluguel de Motos
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            <Card>
              <CardContent className="p-6">
                <h4 className="font-semibold text-gray-900 mb-2">
                  Como funciona o aluguel de moto da Desloca?
                </h4>
                <p className="text-gray-600 text-sm">
                  Nosso <strong>aluguel de moto</strong> é semanal. Você paga uma vez por semana e tem direito
                  a moto zero km, seguro e suporte completo. Troca de óleo por nossa conta nos planos
                  Mensal e Anual — no Fidelidade, todas as manutenções ficam por nossa conta.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h4 className="font-semibold text-gray-900 mb-2">
                  O que está incluído na locação de moto?
                </h4>
                <p className="text-gray-600 text-sm">
                  Nosso <strong>aluguel de motocicleta</strong> inclui: moto DK 160 zero km, seguro completo,
                  IPVA e licenciamento. Nos planos <strong>Mensal e Anual</strong> a troca de óleo é por nossa conta;
                  no plano <strong>Fidelidade</strong>, todas as manutenções ficam por conta da Desloca.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h4 className="font-semibold text-gray-900 mb-2">
                  Qual documentação preciso para alugar uma moto?
                </h4>
                <p className="text-gray-600 text-sm">
                  Para o <strong>aluguel de moto</strong>, você precisa: CNH categoria A válida, 
                  CPF, RG e comprovante de residência. Processo simples e rápido.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h4 className="font-semibold text-gray-900 mb-2">
                  A Desloca atende qual região?
                </h4>
                <p className="text-gray-600 text-sm">
                  Nossa <strong>locadora de motos</strong> atende toda a Baixada Santista: Santos,
                  São Vicente, Praia Grande, Guarujá, Cubatão, Mongaguá, Itanhaém e Peruíbe.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h4 className="font-semibold text-gray-900 mb-2">
                  Posso usar a moto para trabalho?
                </h4>
                <p className="text-gray-600 text-sm">
                  Sim! Nosso <strong>aluguel de moto</strong> é ideal para motoboys, entregadores, 
                  Uber Eats, iFood e outros serviços de delivery na região.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <h4 className="font-semibold text-gray-900 mb-2">
                  Como é o suporte da locadora?
                </h4>
                <p className="text-gray-600 text-sm">
                  Nossa <strong>locadora de motos</strong> oferece suporte completo: troca de óleo por nossa
                  conta nos planos Mensal e Anual, todas as manutenções por conta da Desloca no plano Fidelidade,
                  além de suporte técnico e atendimento personalizado.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Call to action final */}
        <div className="text-center mt-12 p-8 bg-green-600 rounded-xl text-white">
          <h3 className="text-2xl font-bold mb-4">
            Pronto para alugar sua moto com a Desloca?
          </h3>
          <p className="text-lg mb-6">
            Faça seu <strong>aluguel de moto</strong> agora mesmo! Entre em contato e garanta sua motocicleta hoje.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/5513996208062" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white text-green-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              📱 WhatsApp: (13) 99620-8062
            </a>
            <button 
              onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
              className="bg-green-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition-colors"
            >
              Ver Planos de Aluguel
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SeoContent;